import { render } from "./SwiperProducImage.vue?vue&type=template&id=02d07bbc&ts=true"
import script from "./SwiperProducImage.vue?vue&type=script&lang=ts"
export * from "./SwiperProducImage.vue?vue&type=script&lang=ts"

import "./SwiperProducImage.vue?vue&type=style&index=0&id=02d07bbc&lang=scss"
import "./SwiperProducImage.vue?vue&type=style&index=1&id=02d07bbc&lang=postcss"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__